module.exports = __webpack_public_path__ + "img/BSC-active.0ba20202.png";